import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailPageContentRendererInterface
} from "@gea-waldviertler-website/gea-models";
import { WagtailContentRendererFactory } from "./factory.content-renderer";

@Component({
  selector: 'gea-shop-wagtail-element',
  template: `<ng-container #componentContainer />`,
  standalone: false
})
export class WagtailElementComponent {

  @ViewChild('componentContainer', { read: ViewContainerRef, static: true }) public componentContainer!: ViewContainerRef

  private _el: WagtailPageContentElementInterface<WagtailPageContentRendererInterface> | null = null

  @Input() set element(value: WagtailPageContentElementInterface<WagtailPageContentRendererInterface> | null) {
    this._el = value
    if (this._el) {
      // render immediately on input change
      WagtailContentRendererFactory.renderContentElement(this.componentContainer, this._el)
    }
  }

  constructor() {
  }
}
